import { getHelpSearchChunks } from "./helpContent";

/**
 * In-browser help search: token match + phrase bonus (no network, no API cost).
 * Pure JavaScript so Create React App 4 can compile without special loaders.
 * For real semantic/embedding search later, you could precompute chunk vectors at
 * build time or load @xenova/transformers and cosine-search in a Web Worker.
 */
function tokenize(s) {
  return String(s)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .split(" ")
    .map((t) => t.trim())
    .filter((t) => t.length > 0);
}

function scoreMatch(terms, rawQuery, item) {
  const hay = item.searchText.toLowerCase();
  const title = (item.sectionTitle || "").toLowerCase();
  let score = 0;
  const q = rawQuery.trim().toLowerCase();
  if (q.length >= 3 && hay.includes(q)) {
    score += 25;
  }
  for (const t of terms) {
    if (t.length < 2) continue;
    if (title.includes(t)) score += 4;
    const re = new RegExp(t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "g");
    const inHay = (hay.match(re) || []).length;
    score += Math.min(6, 2 * inHay);
  }
  return score;
}

export function buildHelpIndex(sections) {
  const chunks = getHelpSearchChunks(sections);
  return { chunks };
}

/** @returns {Array<{ item: object, score: number }>} */
export function searchHelp(helpIndex, query, limit = 8) {
  const q = (query && query.trim()) || "";
  if (!q) return [];
  const terms = tokenize(q);
  if (terms.length === 0) return [];

  const { chunks } = helpIndex;
  const out = [];
  for (const item of chunks) {
    const score = scoreMatch(terms, q, item);
    if (score > 0) {
      out.push({ item, score });
    }
  }
  out.sort((a, b) => b.score - a.score);
  return out.slice(0, limit);
}
